import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";
import {
  FILTER_TYPES,
  COURSE_STANDARDS_STATUS_TYPES,
} from "PlannerElementDataSet/modules/PlannerElementDataSetConstants";

export const FILTERS_TO_SHOW = [
  FILTER_TYPES.GRADES,
  FILTER_TYPES.SUBJECT_AREAS,
  FILTER_TYPES.TAGS,
  FILTER_TYPES.STATUS,
  FILTER_TYPES.SHOW,
];

export const SHOW_FILTER_TYPES = {
  ALL: "ALL",
  POWER_STANDARD: "POWER_STANDARD",
};

export const PRS_QUICK_COPY_APPLY_SCOPES = {
  SINGLE_STUDENT: "SINGLE_STUDENT",
  MULTIPLE_STUDENTS: "MULTIPLE_STUDENTS",
  MULTIPLE_CLASSES: "MULTIPLE_CLASSES",
};

export const FILTER_TYPE_TO_VARIABLE_NAME = {
  [FILTER_TYPES.SEARCH]: "searchText",
  [FILTER_TYPES.STATUS]: "archivalState",
  [FILTER_TYPES.SHOW]: "isPowerStandard",
  [FILTER_TYPES.GRADES]: "grades",
  [FILTER_TYPES.SUBJECT_AREAS]: "subjects",
  [FILTER_TYPES.TAGS]: "tags",
};

export const DEFAULT_FILTERS = {
  [FILTER_TYPES.SEARCH]: "",
  [FILTER_TYPES.STATUS]: COURSE_STANDARDS_STATUS_TYPES.ALL,
  [FILTER_TYPES.GRADES]: [],
  [FILTER_TYPES.SUBJECT_AREAS]: [],
  [FILTER_TYPES.TAGS]: [],
  [FILTER_TYPES.SHOW]: SHOW_FILTER_TYPES.ALL,
};

export const SHOW_FILTER_OPTIONS = t => [
  {
    id: SHOW_FILTER_TYPES.ALL,
    label: t("scopeAndSequence:all_standards"),
  },
  {
    id: SHOW_FILTER_TYPES.POWER_STANDARD,
    label: t("scopeAndSequence:power_standards_only"),
  },
];

export const COURSE_STANDARD_STATUS_OPTIONS = t => [
  {
    id: COURSE_STANDARDS_STATUS_TYPES.ALL,
    label: t("common:all"),
  },
  {
    id: COURSE_STANDARDS_STATUS_TYPES.ACTIVE,
    label: t("common:active"),
  },
  {
    id: COURSE_STANDARDS_STATUS_TYPES.ARCHIVED,
    label: t("common:archived"),
  },
];

export const FEEDLIST_COLUMN_IDS = {
  NAME: "NAME",
  NAVIGATOR: "NAVIGATOR",
  STANDARDS_SELECTED: "STANDARDS_SELECTED",
};

export const FEEDLIST_UI_TYPES = {
  TEXT: "TEXT",
  BUTTON: "BUTTON",
  NUMBER_TEXT: "NUMBER_TEXT",
};

export const FEEDLIST_PROPERTIES_BY_COLUMN_ID = t => ({
  [FEEDLIST_COLUMN_IDS.NAME]: {
    id: FEEDLIST_COLUMN_IDS.NAME,
    type: "CUSTOM",
    label: t("common:name"),
    uiType: FEEDLIST_UI_TYPES.TEXT,
    style: {
      minWidth: "240px",
      maxWidth: "240px",
      width: "100%",
    },
  },
  [FEEDLIST_COLUMN_IDS.STANDARDS_SELECTED]: {
    id: FEEDLIST_COLUMN_IDS.STANDARDS_SELECTED,
    type: "CUSTOM",
    label: t("common:selected_label", {
      label: t("common:standard_other"),
    }),
    uiType: FEEDLIST_UI_TYPES.NUMBER_TEXT,
    style: {
      width: "124px",
    },
  },
  [FEEDLIST_COLUMN_IDS.NAVIGATOR]: {
    id: FEEDLIST_COLUMN_IDS.NAVIGATOR,
    label: "",
    type: "CUSTOM",
    uiType: FEEDLIST_UI_TYPES.BUTTON,
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "80px",
    },
  },
});

export const FEEDLIST_COLUMN_LIST = [
  FEEDLIST_COLUMN_IDS.NAME,
  FEEDLIST_COLUMN_IDS.STANDARDS_SELECTED,
  FEEDLIST_COLUMN_IDS.NAVIGATOR,
];

export const FILTERS_TO_DATA_GRID_COLUMN_ID = {
  [FILTER_TYPES.GRADES]: DATA_GRID_COLUMN_TYPES.GRADE_LEVELS,
  [FILTER_TYPES.SUBJECT_AREAS]: DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS,
  [FILTER_TYPES.SHOW]: DATA_GRID_COLUMN_TYPES.POWER_STANDARD,
  [FILTER_TYPES.TAGS]: DATA_GRID_COLUMN_TYPES.TAGS,
};

export const NODE_SOURCES = {
  COURSE: "COURSE",
  ALL: "ALL",
};

export const NODE_SOURCE_OPTIONS = t => [
  {
    value: NODE_SOURCES.COURSE,
    label: t("scopeAndSequence:tagged_in_this_label", {
      label: t("course:course"),
    }),
  },
  { value: NODE_SOURCES.ALL, label: t("common:all") },
];
